"use client";

import { createContext, useContext, useState, ReactNode } from "react";

interface FooterVisibilityContextType {
	hideFooter: boolean;
	setHideFooter: (hide: boolean) => void;
	hideHeader: boolean;
	setHideHeader: (hide: boolean) => void;
}

const FooterVisibilityContext = createContext<FooterVisibilityContextType | undefined>(undefined);

export function FooterVisibilityProvider({ children }: { children: ReactNode }) {
	const [hideFooter, setHideFooter] = useState(false);
	const [hideHeader, setHideHeader] = useState(false);

	return (
		<FooterVisibilityContext.Provider value={{ hideFooter, setHideFooter, hideHeader, setHideHeader }}>
			{children}
		</FooterVisibilityContext.Provider>
	);
}

export function useFooterVisibility() {
	const context = useContext(FooterVisibilityContext);
	if (context === undefined) {
		throw new Error("useFooterVisibility must be used within a FooterVisibilityProvider");
	}
	return context;
}
